import fetch from '@/utils/fetch'

// 获取列表接口
export const getList = '/members/black_user/lists'

// 获取黑名单触发配置
export function getMembersBlackUser (params) {
  return fetch({
    url: '/members/black_user/get_user_type_config',
    method: 'get',
    params
  })
}

// 设置黑名单触发配置
export function postMembersBlackUser (params) {
  return fetch({
    url: '/members/black_user/set_user_type_config',
    method: 'post',
    data: params
  })
}

// 修改黑名单开启状态
export function postMembersBlackUserUpdate (params) {
  return fetch({
    url: '/members/black_user/update_open_status',
    method: 'post',
    data: params
  })
}
